import { jsx as _jsx } from "react/jsx-runtime";
import { isValidElement } from 'react';
export { renderToAbstractCanvas } from "./renderToAbstractCanvas.js";
export function ReactRendering({ rendering, }) {
    return isValidElement(rendering.reactElement) ? (rendering.reactElement) : (_jsx("g", { dangerouslySetInnerHTML: { __html: rendering.html || '' } }));
}
export { getSerializedSvg } from "./offscreenCanvasGetSerializingSvg.js";
export async function renderingToSvg(rendering, width, height) {
    if (rendering.canvasRecordedData && !rendering.html) {
        const { getSerializedSvg } = await import("./offscreenCanvasGetSerializingSvg.js");
        const html = await getSerializedSvg({
            width,
            height,
            canvasRecordedData: rendering.canvasRecordedData,
        });
        return { ...rendering, html };
    }
    return rendering;
}
